function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-audit");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-audit",
  fill: "#999999",
  fillRule: "nonzero",
  className: "svg-image"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4,14.4 C8.422425,14.4 6,11.977575 6,9 C6,6.022425 8.422425,3.6 11.4,3.6 C14.377575,3.6 16.8,6.022425 16.8,9 C16.8,11.977575 14.377575,14.4 11.4,14.4 Z M11.4,4.8 C9.0841125,4.8 7.2,6.6841125 7.2,9 C7.2,11.3158875 9.0841125,13.2 11.4,13.2 C13.7158875,13.2 15.6,11.3158875 15.6,9 C15.6,6.6841125 13.7158875,4.8 11.4,4.8 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,18 L1.8,18 C0.8074875,18 0,17.19255 0,16.2 L0,4.2 C0,3.2074875 0.8074875,2.4 1.8,2.4 L3.6,2.4 C4.0979625,2.4 4.87215,2.0793375 5.224275,1.7272125 L5.9272125,1.024275 C6.511125,0.440325 7.5742125,0 8.4,0 L14.4,0 C15.225825,0 16.2889125,0.4403625 16.8727875,1.024275 L17.575725,1.727175 C17.92785,2.0793375 18.7020375,2.4 19.2,2.4 L21,2.4 C21.99255,2.4 22.8,3.2074875 22.8,4.2 L22.8,16.2 C22.8,17.19255 21.99255,18 21,18 Z M1.8,3.6 C1.469175,3.6 1.2,3.869175 1.2,4.2 L1.2,16.2 C1.2,16.530825 1.469175,16.8 1.8,16.8 L21,16.8 C21.330825,16.8 21.6,16.530825 21.6,16.2 L21.6,4.2 C21.6,3.869175 21.330825,3.6 21,3.6 L19.2,3.6 C18.374175,3.6 17.3110875,3.1596375 16.7272125,2.575725 L16.024275,1.872825 C15.67215,1.5206625 14.8979625,1.2 14.4,1.2 L8.4,1.2 C7.9020375,1.2 7.12785,1.5206625 6.775725,1.8727875 L6.0727875,2.575725 C5.488875,3.159675 4.4257875,3.6 3.6,3.6 L1.8,3.6 Z",
  id: "Shape"
})));

var SvgAudit = function SvgAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "18px",
    viewBox: "0 0 23 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audit.459af168.svg";
export { ForwardRef as ReactComponent };